import { useTranslate } from '../../lib'
import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import { CustomChat } from '../CustomChat'
import { SelectNesting } from '../common/Inputs/Select'

export default function WizardStep6({ 
  formData, 
  setFormData, 
  refs,
  customChats,
  fetchCustomChats
}) {
  const { t } = useTranslate();

  return (
    <div className="wizard-step">
      <h2 className="mb-4" style={{ color: '#0B5FA3', fontSize: 20 }}>
        {t('menu.genai.chatSettings')}
      </h2>

      <div className="flex flex-row items-center" style={{marginLeft: 20}}>
        <div className="inputs">
          <div className="input">
            <div className='d-flex flex-column w-100'>
              <div className="d-flex flex-row align-items-center mt-2">
                <span style={{ fontSize: 14 }}>{t('menu.resolutionTime')}:</span>
                <img id="hold-attempts-tp" src="/icons/tooltip-indicator-icon.svg" className="ml-2 cursor-pointer tooltip-nesting" alt="" />
                <Tooltip openOnClick={true} anchorSelect="#hold-attempts-tp"
                  html={t('menu.resolutionTimeTooltip')} place="top" />
                <input style={{ maxWidth: 113, marginRight: 5 }}
                  ref={refs.resolution_time_ref}
                  className='mt-3 input-data'
                  onChange={(e) => setFormData({ ...formData, resolution_time: e.target.value })} 
                  defaultValue={formData.resolution_time}
                  type="number"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="inputs">
          <div className="input">
            <div className='d-flex flex-column'>
              <div className="d-flex flex-row align-items-center mt-2">
                <span style={{ fontSize: 14 }}>{t('menu.percentageOfAffectation')}:</span>
                <img id="hold-time-tp" src="/icons/tooltip-indicator-icon.svg" className="ml-1 cursor-pointer tooltip-nesting" alt="" />
                <Tooltip openOnClick={true} anchorSelect="#hold-time-tp" className='ml-3'
                  html={t('menu.percentageOfAffectationTooltip')} place="top" />
                <input style={{ maxWidth: 113 }}
                  ref={refs.percentage_affectation_ref}
                  className='mt-3 input-data'
                  onChange={(e) => setFormData({ ...formData, percentage_affectation: e.target.value })} 
                  defaultValue={formData.percentage_affectation}
                  type="number"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-row items-center mt-2" style={{marginLeft: 20}}>
        <div className="inputs">
          <div className="input">
            <div className='d-flex flex-row align-items-center'>
              <span>{t('menu.genai.maximunCallDurations')}:</span>
              <img id="max-user-response-tp" src="/icons/tooltip-indicator-icon.svg" className="ml-1 cursor-pointer tooltip-nesting" alt="" />
              <Tooltip openOnClick={true} anchorSelect="#max-user-response-tp"
                html={t('menu.genai.maximunCallDurationsTooltip')} place="top" />
              <input style={{ maxWidth: 113 }}
                ref={refs.maxUserResponseTime}
                className='ml-3 input-data'
                type="number"
                onChange={(e) => setFormData({ ...formData, maxUserResponseTime: e.target.value })} 
                defaultValue={formData.maxUserResponseTime}
              />
            </div>
          </div>
        </div>

        <div className="inputs" style={{ marginLeft: 20 }}>
          <div className="input">
            <div className='d-flex flex-row align-items-center'>
              <span>{t('menu.genai.replyTime')}:</span>
              <img id="reply-time-tp" src="/icons/tooltip-indicator-icon.svg" className="ml-1 cursor-pointer tooltip-nesting" alt="" />
              <Tooltip openOnClick={true} anchorSelect="#reply-time-tp" html={t('menu.genai.replyTimeTooltip')} place="top" />
              <input style={{ maxWidth: 113 }}
                ref={refs.bot_respose_time_ref}
                onChange={(e) => setFormData({ ...formData, bot_respose_time: e.target.value })} 
                defaultValue={formData.bot_respose_time}
                className='ml-3 input-data'
                type="number"
              />
            </div>
          </div>
        </div>
      </div>

      <div style={{ minWidth: 130, display: 'flex', flexDirection: 'row', marginLeft: 20, marginTop: 5 }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span >{`${t('menu.genderAvatar')}:`}</span>
        </div>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 5 }}>
          <SelectNesting
            boxInfo={true}
            tooltipText={t('menu.genderAvatarTooltip')}
            title=''
            containerClass="d-flex"
            style={{ minWidth: 150 }}
            defaultValue={formData.gender_bot_avatar}
            onChange={(e) => setFormData({ ...formData, gender_bot_avatar: e.target.value })} 
          >
            <option value="male" >{t('common.male')}</option>
            <option value="female">{t('common.female')}</option>
          </SelectNesting>
        </div>
      </div>

      <div className="p-0-mb flex flex-col flex-1" style={{ paddingRight: 20, paddingLeft: 20 }}>
        <div className="inputs" style={{ marginRight: 20, marginTop: 25 }}>
          <div className="input">
            <div className="d-flex flex-row align-center">
              <span>{t('menu.genai.customChat')}:</span>
              <img id="custom-chat" src="/icons/tooltip-indicator-icon.svg" className="ml-2 cursor-pointer tooltip-nesting" alt="" />
              <Tooltip openOnClick={true} anchorSelect="#custom-chat"
                html={t('menu.genai.customChatTooltip')} place="top" />
              <div style={{ maxWidth: 200, minWidth: 100 }}>
                <select
                  className='w-100 select-nesting input-data'
                  style={{ flexGrow: '2', backgroundPositionX: "96%" }}
                  id="custom_chat"
                  onChange={(e) => {
                    const value = e.target.value;
                    setFormData({
                      ...formData,
                      selectedChatOption: value === 'new' || value === '' ? '' : value,
                      showCustomChatForm: value === 'new'
                    });
                  }}
                >
                  {customChats.map((item) => (
                    <option value={item.id} key={item.id}>{item.name}</option>
                  ))}
                  {/* <option value="new">{t('common.new')}</option> */}
                </select>
              </div>
            </div>
          </div>

          {formData.showCustomChatForm && (
            <CustomChat update={() => { fetchCustomChats() }} />
          )}
        </div>
      </div>
    </div>
  );
}
